import React, { type ReactElement } from 'react'
import { Form, Select, Input } from 'antd'
import { connect } from 'react-redux'
import {
    type initialDetailsInterface,
    type IndividualHomeFormDataInterface,
    type initialState,
} from '../../../../../../Types/Client/RegisteredClients/Individual'
import { validateName } from '../../../../../../Utils/Common'

const InitialDetailsForm = (props: initialDetailsInterface): ReactElement => {
    const { categoryDropDownList, onCategorySelect } = props

    return (
        <>
            <Form.Item<IndividualHomeFormDataInterface>
                name="individualId"
                hidden={true}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                name="clientNumber"
                hidden={true}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Client Category"
                name="clientCategoryId"
                rules={[
                    {
                        required: true,
                        message: 'Please Select Client Category',
                    },
                ]}
            >
                <Select
                    allowClear
                    showSearch
                    onChange={(value) => {
                        onCategorySelect(value)
                    }}
                    filterOption={(input, option) =>
                        option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase()) ?? false
                    }
                    options={categoryDropDownList}
                />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                name="title"
                label="Title"
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="First Name"
                name="firstName"
                rules={[
                    {
                        required: true,
                        message: 'Please input your First Name',
                    },
                    {
                        validator: async (rule, value) =>
                            await validateName(rule, value, 'First Name'),
                    },
                ]}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Middle Name"
                name="middleName"
                rules={[
                    {
                        validator: async (rule, value) =>
                            await validateName(rule, value, 'Middle Name'),
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Surname"
                name="surName"
                rules={[
                    {
                        required: true,
                        message: 'Please input your Sure Name',
                    },
                    {
                        validator: async (rule, value) =>
                            await validateName(rule, value, 'Surname'),
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Type Of Self Employment"
                name="typeOfSelfEmployment"
                rules={[
                    {
                        validator: async (rule, value) =>
                            await validateName(
                                rule,
                                value,
                                'Type Of SelfEmployment'
                            ),
                    },
                ]}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Trading Name"
                name="tradingName"
                rules={[
                    {
                        required: true,
                        message: 'Please Enter Business Trading Name',
                    },
                    {
                        validator: async (rule, value) =>
                            await validateName(rule, value, 'Trading Name'),
                    },
                ]}
            >
                <Input allowClear />
            </Form.Item>
            <Form.Item<IndividualHomeFormDataInterface>
                label="Individual UTR"
                name="individualUTR"
            >
                <Input allowClear />
            </Form.Item>
        </>
    )
}

const mapStateToProps = (state: any): initialState => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
    }
}

export default connect(mapStateToProps)(InitialDetailsForm)
